import { fetchAllSuppliers, fetchSupplierById, insertDataProveedor, updateSupplier } from "../../services/proveedor.service";
import { actionTypes } from "../contants/actionTypes";
import { logout } from "./auth";


// INSERT SUPPLIER

export const startAddingNewProveedor = () => ({
    type: actionTypes.floStartAddingNewProveedor
});

export const finishAddingNewSupplier = () => ({
    type: actionTypes.floFinishAddingNewProveedor
});

export const setData = (obj) => ({
    type: actionTypes.supplier,
    payload: obj
});

export const setToken = (token) => ({
    type: actionTypes.token,
    payload: token
});

export const addNewProveedor = (data, accessToken) => {
    return (dispatch) => {
        dispatch(startAddingNewProveedor());
        insertDataProveedor(data, accessToken)
            .then((response) => {
                console.log("response ", response)
                console.log('Proveedor agregado exitosamente:', response.data);
            })
            .catch((e) => {
                console.error('Error al agregar proveedor:', e);
                console.log('Detalles del error:', e.response);
                const errorMessage =
                    e.response?.data?.message ||
                    'Ha ocurrido un error al agregar el proveedor. Por favor, inténtelo más tarde.';
                dispatch({
                    type: actionTypes.floAddNewProveedorError,
                    payload: errorMessage,
                });

                if (e.response?.status === 403 || e.response?.status === 401) {
                    dispatch(logout());
                }
            })
            .finally(() => {
                dispatch(finishAddingNewSupplier());
            });
    };
};

// SUPPLIER BY ID

export const loadingStartSupplier = () => ({
    type: actionTypes.supplierLoadingStartSingle
});

export const loadingFinishSupplier = () => ({
    type: actionTypes.supplierLoadingFinishSingle
});

export const loadSupplier = (data, isErrorLoaded = false) => ({
    type: actionTypes.supplierLoadSuppierById,
    payload: {
        supplierById: data,
        isErrorLoaded
    },
});

export const errorSupplier = (error) => ({
    type: actionTypes.supplierLoadSupplierByIdError,
    payload: error,
});


export const getSupplierById = (accessToken, supplierId) => {
    return (dispatch) => {
        dispatch(loadingStartSupplier());
        fetchSupplierById(accessToken, supplierId)
            .then((response) => {
                dispatch(loadSupplier(response.data));
            }).catch((e) => {
                console.log('error', e);
                if (e.response && e.response.status && (e.response.status === 403 || e.response.status === 401)) {
                    dispatch(logout());
                } else {
                    dispatch(errorSupplier('Ha ocurrido un error, intentálo de nuevo más tarde'));
                }
            }).finally(() => {
                dispatch(loadingFinishSupplier());
            });
    };
};

// UPDATE

export const editsupplier = (data, accessToken) => {
    return (dispatch) => {
        dispatch(loadingUpdateSupplier());
        updateSupplier(data, accessToken)
            .then((response) => {
                dispatch(updateSupplierSuccess(response.data));
            })
            .catch((e) => {
                console.error('Error updating supplier:', e);
                const errorMessage =
                    e.response?.data?.message ||
                    'Error al actualizar el proveedor. Intente nuevamente más tarde.';
                dispatch(updateSupplierError(errorMessage));

                if (e.response?.status === 403 || e.response?.status === 401) {
                    dispatch(logout());
                }
            })
            .finally(() => {
                dispatch(loadingFinishUpdateSupplier());
            });
    };
};

export const loadingUpdateSupplier = () => ({
    type: actionTypes.supplierUpdateStart,
});

export const loadingFinishUpdateSupplier = () => ({
    type: actionTypes.supplierFinishUpdate,
});

export const updateSupplierSuccess = (supplier) => ({
    type: actionTypes.supplierUpdate,
    payload: supplier
});

export const updateSupplierError = (error) => ({
    type: actionTypes.supplierUpdateError,
    payload: error,
});


// LIST_ALL

export const startFetchingSuppliers = () => ({
    type: actionTypes.supplierFetchStart,
});

export const finishFetchingSuppliers = (data) => ({
    type: actionTypes.supplierFetchSuccess,
    payload: data,
});

export const fetchSuppliersError = (error) => ({
    type: actionTypes.supplierFetchError,
    payload: error,
});


export const fetchAllSuppliersAction = (accessToken) => {
    return (dispatch) => {
        dispatch(startFetchingSuppliers());
        fetchAllSuppliers(accessToken)
            .then((response) => {
                dispatch(finishFetchingSuppliers(response.data));
            })
            .catch((e) => {
                console.error("Error al obtener proveedores:", e);
                const errorMessage =
                    e.response?.data?.message ||
                    "Ha ocurrido un error al obtener los proveedores. Por favor, inténtelo más tarde.";
                dispatch(fetchSuppliersError(errorMessage));
            });
    };
};